import { createApi } from '@reduxjs/toolkit/query/react';
import { GraphQLClient } from 'graphql-request';
import { elevioBaseQuery } from 'components/conversation/components/integrations/elevio/src/utils/apis/graphql/baseQuery';
import { elevioUrls, getBackendDomain, resolveElevioUrlByEnvironment, } from '../../../../utils/apis';
import { companySettingsQuery } from './datahub.queries';
const backendDomain = getBackendDomain();
const datahubUrl = resolveElevioUrlByEnvironment({
    production: elevioUrls.production.datahub,
    staging: elevioUrls.staging.datahub,
}, backendDomain);
const datahubClient = new GraphQLClient(datahubUrl);
export const datahubApi = createApi({
    baseQuery: elevioBaseQuery(datahubClient),
    endpoints: (builder) => ({
        companySettings: builder.query({
            query: () => ({
                document: companySettingsQuery,
            }),
        }),
    }),
    reducerPath: 'elevioDatahubApi',
});
